module.exports = __webpack_public_path__ + "media/flags/so-abd24f52.svg";